// extracted by mini-css-extract-plugin
export var footer = "_mv-5";
export var fulfillmentInput = "_mv-0";
export var shipDateInput = "_mv-1";
export var shipmentModal = "_mv-2";
export var shipmentModalContent = "_mv-3";
export var tableContainer = "_mv-4";